
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Banner from "./Banner";
import Headline from "./ Headline";
import { OPD_COUNT } from "../Constant";

const BannerCard = ({ item, navigate, showEdit }) => {

  localStorage?.setItem(
    OPD_COUNT,
    item?.viewMoreTitle ? item?.viewMoreTitle : 4
  );

  return (
    <div>
    
      {showEdit ? (
        <Headline item={item} navigate={navigate} showEdit={showEdit} />
      ) : null}

      <div className="row justify-contet-center ">
        <Banner product={item} showEdit={showEdit} navigate={navigate} />
      </div>
    </div>
  );
};
export default BannerCard;
